import { ledgerActionTypes } from './../constants/ApiConstants';

const initialState = {
  loading: false,
  loadingPayers: false,
  loadingGuarantors: false,
  masterData: null,
  patientPayers: null,
  ledgerDetails: null,
  ledgerClaimServiceDetails: null,
  addedPaymentDetails: null,
  paymentDetails: null,
  patientGuarantors: null,
  patientList: [],
  patientMasterTags: null,
  payment_line_deleted: {},
  paymentStatus_updated: null,
  batchClaimPaymentStatus_updated: null,
  batchClaimOfficeallyStatus_updated: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ledgerActionTypes.get_master_data.REQUEST:
    case ledgerActionTypes.delete_serviceLine_payment.REQUEST:
      return {
        ...state,
        loading: true,
        masterData: null,
      };
    case ledgerActionTypes.get_master_data.SUCCESS:
      return {
        ...state,
        loading: false,
        masterData: payload,
      };
    case ledgerActionTypes.get_patientPayers.REQUEST:
      return {
        ...state,
        loadingPayers: true,
        patientPayers: null,
      };
    case ledgerActionTypes.get_patientPayers.SUCCESS:
      return {
        ...state,
        loadingPayers: false,
        patientPayers: payload,
      };
    case ledgerActionTypes.get_ledgerDetails.REQUEST:
      return {
        ...state,
        loading: true,
        ledgerDetails: null,
      };
    case ledgerActionTypes.get_ledgerDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        ledgerDetails: payload,
      };
    case ledgerActionTypes.get_ledgerClaimServiceDetails.REQUEST:
      return {
        ...state,
        loading: true,
        ledgerClaimServiceDetails: null,
      };
    case ledgerActionTypes.get_ledgerClaimServiceDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        ledgerClaimServiceDetails: payload,
      };
    case ledgerActionTypes.post_paymentDetails.REQUEST:
      return {
        ...state,
        loading: true,
        addedPaymentDetails: null,
      };
    case ledgerActionTypes.post_paymentDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        addedPaymentDetails: payload,
      };
    case ledgerActionTypes.get_paymentDetails.REQUEST:
      return {
        ...state,
        loading: true,
        paymentDetails: payload,
      };
    case ledgerActionTypes.get_paymentDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        paymentDetails: payload,
      };
    case ledgerActionTypes.get_patientGuarantors.REQUEST:
      return {
        ...state,
        loadingGuarantors: true,
        patientGuarantors: null,
      };
    case ledgerActionTypes.get_patientGuarantors.SUCCESS:
      return {
        ...state,
        loadingGuarantors: false,
        patientGuarantors: payload,
      };
    case ledgerActionTypes.get_patient.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ledgerActionTypes.get_patient.SUCCESS:
      return {
        ...state,
        patientList: payload,
        loading: false,
      };
    case ledgerActionTypes.get_patient_master_tags_ForLedger.REQUEST:
      return {
        ...state,
        loading: true,
        patientMasterTags: null,
      };
    case ledgerActionTypes.get_patient_master_tags_ForLedger.SUCCESS:
      return {
        ...state,
        loading: false,
        patientMasterTags: payload,
      };
    case ledgerActionTypes.delete_serviceLine_payment.SUCCESS:
      return {
        ...state,
        payment_line_deleted: payload,
        loading: false,
      };
    case ledgerActionTypes.update_clientPaymentStatus.REQUEST:
    return {
      ...state,
      loading: true,
      paymentStatus_updated: null,
    };
    case ledgerActionTypes.update_clientPaymentStatus.SUCCESS:
    return {
      ...state,
      loading: false,
      paymentStatus_updated: payload,
    };

    case ledgerActionTypes.update_batch_claims_payment_status.REQUEST:
      return {
        ...state,
        loading: true,
        batchClaimPaymentStatus_updated: null,
      };
    case ledgerActionTypes.update_batch_claims_payment_status.SUCCESS:
      return {
        ...state,
        loading: false,
        batchClaimPaymentStatus_updated: payload,
      };
    case ledgerActionTypes.update_batch_claims_officeally_status.REQUEST:
      return {
        ...state,
        loading: true,
        batchClaimOfficeallyStatus_updated: null,
      };
    case ledgerActionTypes.update_batch_claims_officeally_status.SUCCESS:
      return {
        ...state,
        loading: false,
        batchClaimOfficeallyStatus_updated: payload,
      };


    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Billing/components/Ledger/reducers/index.js